import { ExtendedContainer, SkySpine } from "@aceroll/core";

const IDLE_ANIMATION = 'idle';

export default class Logo extends ExtendedContainer {
    constructor() {
        super();

        this.spine = this.addChild(new SkySpine('spine-logo'));
        this.visible = false;
    }

    async show() {
        this.visible = true;
        this.spine.setImmediately(IDLE_ANIMATION, true);
    }

    async hide() {
        this.visible = false;
        this.spine.stop();
    }
}